export const ChangeLogs = () => {
  return <div className="h-full flex-1 flex-col space-y-4 pl-8 lg:pl-0 pr-8">TODO</div>;
};
